import { render, staticRenderFns } from "./AddProductModal.vue?vue&type=template&id=a3f67f20&scoped=true"
import script from "./AddProductModal.vue?vue&type=script&lang=js"
export * from "./AddProductModal.vue?vue&type=script&lang=js"
import style0 from "./AddProductModal.vue?vue&type=style&index=0&id=a3f67f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3f67f20",
  null
  
)

export default component.exports